import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectVideo24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMediaObjectVideo24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 4.5h6.5A1.5 1.5 0 0 1 13 6v12a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 18V6A1.5 1.5 0 0 1 5 4.5M2 6a3 3 0 0 1 3-3h6.5a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm15 .5A.75.75 0 0 0 17 8h4.227a.75.75 0 0 0 0-1.5zm-.75 4.25A.75.75 0 0 1 17 10h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75m-5.078 2.055a1 1 0 0 0 0-1.61L7.093 8.19a1 1 0 0 0-1.593.805v6.01a1 1 0 0 0 1.593.805zM7 9.985 9.736 12 7 14.016z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectVideo24);
